module.exports = [{"key":"1","name":"天然气方案","type":"二期","time":"2017-08-24"},{"key":"2","name":"酒店方案1","type":"一期","time":"2017-08-24"},{"key":"3","name":"政府方案1","type":"二期","time":"2017-08-24"}]


//////////////////
// WEBPACK FOOTER
// ./src/mocks/scheme/datas_scheme_portal.json
// module id = 545
// module chunks = 0